import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
`;
const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 39px;
  height: 22px;
`;
const Input = styled.input`
  display: none;
  
  &:checked + span:before {
    transform: translateX(17px);
    background-color: ${({ theme }) => theme.colors.institucional};
  }  
  &:checked + span {
    border-color: ${({ theme }) => theme.colors.institucional};
  }
}
`;
const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border: 2px solid ${({ theme }) => theme.colors.gray300};
  transition: border-color 0.3s;
  border-radius: 50px;

  &:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 2px;
    bottom: 2px;
    background-color: ${({ theme }) => theme.colors.gray500};
    transition: transform 0.3s, background-color 0.3s;
    border-radius: 50%;
  }
`;
const Description = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.gray300};
  margin-left: 9px;
`;
export default function Switch({ name, description }) {
  return (
    <Container>
      <Label>
        <Input name={name} type="checkbox" />
        <Slider />
      </Label>
      {description && <Description>{description}</Description>}
    </Container>
  );
}

Switch.propTypes = {
  description: PropTypes.string,
  name: PropTypes.string,
};
Switch.defaultProps = {
  description: '',
  name: 'switch',
};
